import PropTypes from "prop-types";
import * as React from "react";
import css from "./AdvancedSettings.module.css";
import GroupShopSettings from "../InfluencerModal/GroupShopSettings";

export default function GroupShopSection({
  influencerId,
  isGroupShop,
  shopHashTag,
  setShopHashTag,
  onInput,
  onKeyDown,
}) {
  return (
    <div className={css.groupShopWrapper}>
      <GroupShopSettings
        influencerId={influencerId}
        isGroupShop={isGroupShop}
        shopHashTag={shopHashTag}
        setShopHashTag={setShopHashTag}
        onInput={onInput}
        onKeyDown={onKeyDown}
      />
    </div>
  );
}

GroupShopSection.propTypes = {
  influencerId: PropTypes.number.isRequired,
  isGroupShop: PropTypes.bool.isRequired,
  shopHashTag: PropTypes.string,
  setShopHashTag: PropTypes.func.isRequired,
  onInput: PropTypes.func,
  onKeyDown: PropTypes.func,
};
